import axios from 'axios';

// Use HTTPS for production
const API_BASE_URL = '';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

const apiService = {
  health: async () => {
    const response = await apiClient.get('/api/health');
    return response.data;
  },

  // NEW: Models status endpoint
  modelsStatus: async () => {
    const response = await apiClient.get('/api/models/status');
    return response.data;
  },

  acousticPredict: async (caseId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(`/api/acoustic/predict/${caseId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  radiologyPredict: async (caseId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(`/api/radiology/predict/${caseId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  fusionAnalyze: async (caseId, audioFile, imageFile) => {
    const formData = new FormData();
    formData.append('case_id', caseId.toString());
    if (audioFile) formData.append('audio_file', audioFile);
    if (imageFile) formData.append('image_file', imageFile);
    const response = await apiClient.post('/api/ctf/analyze', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  signup: async (email, password, fullName) => {
    const response = await apiClient.post('/api/auth/signup', {
      email,
      password,
      full_name: fullName,
    });
    return response.data;
  },

  login: async (email, password) => {
    const response = await apiClient.post('/api/auth/login', {
      email,
      password,
    });
    return response.data;
  },

  submitFeedback: async (name, email, subject, message) => {
    const response = await apiClient.post('/api/feedback', {
      name,
      email,
      subject,
      message,
      timestamp: new Date().toISOString(),
    });
    return response.data;
  },

  getFeedback: async () => {
    const response = await apiClient.get('/api/feedback');
    return response.data;
  },
};

export default apiService;
